export const VendorSitesColorMapInfo: any = {
  "active": "#9AF0E1",
  "inactive": "#FFD0D3"
}